<template>
    <div v-click-outside="closeConsultant">
        <transition name="slide">
            <div v-show="openModule">
                <div
                    class="opened"
                    :class="!paid && ! availableLicenses ? 'freeOpened' : 'paidOpened'"
                >
                    <div v-if="!paid && ! availableLicenses" class="no-access">
                        <img src="@/assets/images/M3/M3Sketch/warn-sign-white.png" alt="">
                        <p class="title"><strong>Funcție disponibilă utilizatorilor licențiați</strong></p>
                        <p>Alegi varianta cu licență a aplicației și ai acces la un
                            consultant dedicat care te va consilia în utilizarea aplicației și îți va oferi cele mai bune
                            sfaturi în scrierea proiectului.</p>
                        <router-link to="/aplicatii/m3-sketch/licente/comanda-licenta" class="green-button">Achiziționează licența</router-link>
                    </div>
                    <div v-else-if="(paid || availableLicenses > 0) && data && !data.name" class="no-access">
                        <img src="@/assets/images/M3/M3Sketch/warn-sign-white.png" alt="">
                        <p class="title"><strong>Consultant în curs de atribuire</strong></p>
                        <p>Dacă ai nevoie de un consultant personal mai repede, ne poți apela la 0722 114 395 sau să ne trimiți un mail la office@smis.ro.</p>
                    </div>
                    <img src="@/assets/images/M3/M3Sketch/consultant-logo-smis.png" alt="">
                    <img v-if="paid && data && data.user_logo" :src="data.user_logo ? data.user_logo : ''" class="consultant-avatar" alt="">
                    <img v-else src="@/assets/images/M3/M3Sketch/consultant-avatar.png" class="consultant-avatar" alt="">
                    <ul class="contact-details">
                        <li class="flex space-between align-center">
                            <div class="details">
                                <p v-if="paid && data && data.name" class="name">{{ data.name }}</p>
                                <p v-else class="name">Popescu Marius</p>
                                <p>consultantul tău Smis</p>
                            </div>
                            <!--                        <div class="icon" @click="openTawk()">
                                                        <font-awesome-icon :icon="['fab', 'facebook-messenger']"></font-awesome-icon>
                                                    </div>-->
                        </li>
                        <li class="flex space-between align-center">
                            <div class="details">
                                <p v-if="paid && data && data.email">{{ data.email }}</p>
                                <p v-else>consultant@smis.ro</p>
                                <p v-if="paid && data && data.phone">{{ data.phone }}</p>
                                <p v-else>0722 222 222</p>
                            </div>
                            <div v-if="paid && data" class="icon">
                                <a :href="'https://wa.me/'+data.whatsapp_phone" target="_blank">
                                    <font-awesome-icon :icon="['fab', 'whatsapp']"></font-awesome-icon>
                                </a>

                            </div>
                        </li>
                    </ul>
                </div>
                <div v-if="paid || availableLicenses > 0" class="blue-button" @click="changePage('/aplicatii/m3-sketch/intrebari-frecvente')">
                    <p>Vezi întrebări frecvente</p>
                </div>
                <div v-if="paid || availableLicenses > 0" class="blue-button" @click="changePage('/aplicatii/m3-sketch/tichete-suport')">
                    <p>Deschide tichet de suport</p>
                </div>
            </div>
        </transition>
        <LicentaM3
            :licentaPopup="modalShow"
            @hideTempModal="modalShow = false"
        ></LicentaM3>
    </div>
</template>


<script>
    import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faChevronUp} from '@fortawesome/free-solid-svg-icons'
    import {faChevronDown} from '@fortawesome/free-solid-svg-icons'
    import {faFacebookMessenger} from '@fortawesome/free-brands-svg-icons'
    import {faWhatsapp} from '@fortawesome/free-brands-svg-icons'
    import Vue from 'vue'
    import LicentaM3 from '@/pages/Aplicatii/M3/M3Sketch/components/LicentaM3'

    Vue.directive('click-outside', {
        bind: function (el, binding, vnode) {
            el.clickOutsideEvent = function (event) {
                // here I check that click was outside the el and his children
                if (!(el == event.target || el.contains(event.target))) {
                    // and if it did, call method provided in attribute value
                    vnode.context[binding.expression](event);
                }
            };
            document.body.addEventListener('click', el.clickOutsideEvent)
        },
        unbind: function (el) {
            document.body.removeEventListener('click', el.clickOutsideEvent)
        },
    });


    library.add(faChevronUp, faChevronDown, faFacebookMessenger, faWhatsapp)
    export default {
        components: {
            FontAwesomeIcon,
            LicentaM3
        },

        props: {
            data: null,
            openModule: null,
            paid: null,
            availableLicenses: null
        },

        data() {
            return {
                opened: false,
                serviceType: 'paid',
                modalShow: false,
            }
        },
        watch: {
        },
        mounted() {
            /*if(this.$route.fullPath.includes('m3-sketch')){
                Vue.use(Tawk, {
                    tawkSrc: 'https://embed.tawk.to/619f9cd16885f60a50bd8aad/1flbnp532'
                })
                this.user = {
                    name: this.$store.state.auth.user.name,
                    email: this.$store.state.auth.user.email,
                }
                this.$Tawk.$updateChatUser(this.user)
            }*/
            if (this.paid) {
                this.serviceType = 'paid'
            } else {
                this.serviceType = 'free'
            }
        },
        methods: {
            openConsultant() {
                this.openModule = !this.openModule;
            },
            closeConsultant() {
                this.$emit('closeConsultant')
            },
            changePage(page) {
                this.$router.push({path: page})
                this.$emit('closeConsultant')
            }
        }
    }
</script>

<style scoped>
.blue-button{
    background: #007cde;
    padding: 8px 20px;
    min-height: 38px;
    margin-top: 10px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: 0.4s;
}
.blue-button:hover{
    background: #0268b9;
}
.blue-button p{
    color: #fff;
}
.personal-consultant {
    position: absolute;
    bottom: 0;
    left: 56px;
    width: 100%;
    max-width: 300px;
}

.closed {
    padding: 10px 7px;
    height: 100%;
    width: 100%;
    display: flex;
    max-height: 35px;
    max-width: 195px;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    transition-delay: 0.2s;
    transition-duration: 0.6s;
    transition-timing-function: ease-in;
}

.close-wide {
    max-width: 490px;
}

.closed-preview {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.opened {
    padding: 20px 20px 10px 20px;
    border-radius: 6px;
    height: 100%;
    width: 100%;
    display: flex;
    max-width: 290px;
    max-height: 490px;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    position: relative;
    transition: 0.8s;
}

.closed img {
    max-height: 23px;
    object-fit: contain;
}

.closed p, .closed-preview p {
    font-size: 15px;
    font-weight: 700;
    color: #fff;
    margin: 0;
}

.closed svg, .closed-preview svg {
    color: #fff;
}

.free {
    background: linear-gradient(to bottom, #f78a9e, #fe988b);
}

.freeOpened {
    background: linear-gradient(to top, #f78a9e, #fe988b);
    bottom: 0;
}

.paidOpened {
    background: linear-gradient(to bottom, #01e9bd -26%, #007cde 83%);
    bottom: 0px;
}

.paid {
    background: linear-gradient(to top, #01e9bd -26%, #007cde 83%);
}

.consultant-avatar {
    border-radius: 50%;
    border: 5px solid #fff;
    max-height: 200px;
    margin: 20px 0;
}

.space-between {
    justify-content: space-between;
}

.contact-details {
    width: 100%;
    margin-top: 10px;
}

.contact-details li {
    margin-bottom: 15px;
}

.details p {
    font-size: 13px;
    color: #fff;
    margin: 0;
}

.details .name {
    font-size: 21px;
    font-weight: 700;
}

.icon >>> svg {
    font-size: 40px;
    color: #fff;
}

.no-access {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 100%;
    max-width: 90%;
    height: 100%;
    max-height: 80%;
    background: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(1px);
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 30px;
}

.no-access .title {
    font-size: 15px;
    margin: 10px 0;
    font-weight: 500;
    color: #fff;
}

.no-access p {
    font-size: 11px;
    color: #fff;
    text-align: center;
}

.green-button {
    padding: 6px 20px;
    border-radius: 5px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #161616;
    background: #2ce4c3;
    margin-top: 25px;
    cursor: pointer;
    text-align: center;
    font-weight: 600;
}
.green-button:hover{
    text-decoration: none;
}
.slide-enter-active {
    transition-duration: 0.5s;
    transition-timing-function: ease-in;
}

.slide-leave-active {
    transition-duration: 0.5s;
    transition-timing-function: ease-in;
}

.slide-enter-to, .slide-leave {
    max-height: 585px;
    overflow: hidden;
}

.slide-enter, .slide-leave-to {
    max-height: 0;
    overflow: hidden;
}
</style>
